enum ModalState {
  // Initial state:
  NONE = 'NONE',

  // Add email modals:
  ADD_EMAIL_FORM = 'ADD_EMAIL_FORM',
  ADD_EMAIL_CONFIRMATION = 'ADD_EMAIL_CONFIRMATION',
  ADD_EMAIL_DISMISS_CONFIRMATION = 'ADD_EMAIL_DISMISS_CONFIRMATION',

  // Change password modals:
  CHANGE_PASSWORD_INTRO = 'CHANGE_PASSWORD_INTRO',
  CHANGE_PASSWORD_FORM = 'CHANGE_PASSWORD_FORM',
  CHANGE_PASSWORD_CONFIRMATION = 'CHANGE_PASSWORD_CONFIRMATION',
  CHANGE_PASSWORD_DISMISS_CONFIRMATION = 'CHANGE_PASSWORD_DISMISS_CONFIRMATION',

  // Account pin modals:
  ACCOUNT_PIN_FORM = 'ACCOUNT_PIN_FORM',
  ACCOUNT_PIN_FORM_EXPIRED = 'ACCOUNT_PIN_FORM_EXPIRED'
}

export default ModalState;
